import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import 'primeicons/primeicons.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { ToastContainer } from "react-toastify";
const Home = lazy(() => import('./Pages/Home'));
const VideoPage = lazy(() => import('./Pages/VideoPage'));
const CategoryPage = lazy(() => import('./Pages/CategoryPage'));
const AllVideos = lazy(() => import('./Pages/AllVideos'));
const Favorites = lazy(() => import('./Pages/Favorites'));
const WatchLater = lazy(() => import('./Pages/WatchLater'));
const Login = lazy(() => import('./Pages/Login'));
const Redirect = lazy(() => import('./Pages/Redirect'));





function App(){
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path='/'  element={<Home/>} />
        <Route path='/video/:id' element={<VideoPage/>} />
        <Route path='/category/:cat' element={<CategoryPage/>} />
        <Route path='/all-videos' element={<AllVideos/>} />
        <Route path='/favorites' element={<Favorites/>} />
        <Route path='/watch-later' element={<WatchLater/>} />
        <Route path='/subscribe' element={<Login/>} />
        <Route path='/redirect' element={<Redirect/>} />

      </Routes>
    </Suspense>
  );
}

export default App;
